import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/apiService';
import './MobileHelpCentrePage.css';

const SUGGESTED = [
  { q: 'How do I verify my email address?', hint: 'verify' },
  { q: "What can I do if I failed to sign into my account?", hint: 'sign' },
  { q: 'Why cannot I receive the SMS verification code?', hint: 'sms' },
  { q: 'How do I change my email address?', hint: 'change' },
  { q: 'What can I do if my account was deactivated?', hint: 'deactiv' },
];

const MobileHelpCentrePage = () => {
  const navigate = useNavigate();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [openFaqId, setOpenFaqId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/faq');
        if (!cancelled) setFaqs(Array.isArray(res.data) ? res.data : []);
      } catch {
        if (!cancelled) setFaqs([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const matchFaq = (hint) => {
    const h = hint.toLowerCase();
    return faqs.find((f) => (f.question || '').toLowerCase().includes(h));
  };

  const filteredFaqs = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return faqs.slice(0, 5);
    return faqs.filter((f) => (f.question || '').toLowerCase().includes(q) || (f.answer || '').toLowerCase().includes(q));
  }, [faqs, search]);

  const openSuggested = (hint) => {
    const m = matchFaq(hint);
    navigate('/faq', m ? { state: { highlightQuestion: m.question } } : {});
  };

  return (
    <div className="mhc-page">
      <button type="button" className="mhc-back" onClick={() => navigate(-1)} aria-label="Back">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <h1 className="mhc-title">How can we help?</h1>

      <div className="mhc-search-wrap">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          className="mhc-search"
          placeholder="Search or ask a question"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          aria-label="Search help"
        />
      </div>

      <button type="button" className="mhc-card" onClick={() => navigate('/my-support')}>
        <span>Service request progress</span>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>

      <h2 className="mhc-section-title">Suggested for you</h2>
      {SUGGESTED.map((s) => (
        <button key={s.q} type="button" className="mhc-suggest-item" onClick={() => openSuggested(s.hint)}>
          <span>{s.q}</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      ))}

      <div className="mhc-faq-head">
        <h2 className="mhc-section-title" style={{ margin: 0 }}>FAQs</h2>
        <button type="button" className="mhc-viewall" onClick={() => navigate('/faq')}>
          View all
        </button>
      </div>

      {loading ? (
        <div className="mhc-loading">Loading…</div>
      ) : (
        filteredFaqs.map((faq) => (
          <div key={faq.id}>
            <button
              type="button"
              className="mhc-faq-item"
              onClick={() => setOpenFaqId((id) => (id === faq.id ? null : faq.id))}
            >
              <span>{faq.question}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            {openFaqId === faq.id && faq.answer && (
              <div className="mhc-faq-answer">{faq.answer}</div>
            )}
          </div>
        ))
      )}

      <button type="button" className="mhc-live" onClick={() => navigate('/mobile/messenger')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        Live chat
      </button>
    </div>
  );
};

export default MobileHelpCentrePage;
